import React from 'react';
import { Badge } from 'src/components/badge';
import { Icon } from 'src/components/icon';
import { useLocale } from 'src/hooks/use-locale';

export const LimitedTimeOfferBadge = () => {
  const t = useLocale();

  return (
    <Badge
      icon={<Icon name="star" />}
      testAttr="limited-time-offer-badge"
      textTestAttr="limited-time-offer-text"
    >
      {t('special_offer')}
    </Badge>
  );
};
